module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header filled full-block light"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 deal_page_container"
  }, [_c('div', [_c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == 'no' || _vm.deal.edit != _vm.deal.deal_title),
      expression: "deal.edit=='no' || deal.edit!=deal.deal_title"
    }],
    staticClass: "pointer inline-block",
    on: {
      "click": function($event) {
        _vm.deal.edit = _vm.deal.deal_title;
        _vm.content_cache = _vm.deal.deal_title
      }
    }
  }, [_vm._v(_vm._s(_vm.deal.deal_title))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == _vm.deal.deal_title),
      expression: "deal.edit==deal.deal_title"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "blur": function($event) {
        _vm.deal.edit = 'no';
        _vm.deal.deal_title = _vm.content_cache;
        _vm.updateDeal(_vm.deal)
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == 'no' || _vm.deal.edit != _vm.deal.deal_value),
      expression: "deal.edit=='no' || deal.edit!=deal.deal_value"
    }],
    staticClass: "deal_page_info pointer inline-block",
    on: {
      "click": function($event) {
        _vm.deal.edit = _vm.deal.deal_value;
        _vm.content_cache = _vm.deal.deal_value
      }
    }
  }, [_vm._v(_vm._s(_vm.DealPrice))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == _vm.deal.deal_value),
      expression: "deal.edit==deal.deal_value"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.content_cache),
      expression: "content_cache"
    }],
    staticClass: "inline-edit-input",
    domProps: {
      "value": (_vm.content_cache)
    },
    on: {
      "blur": function($event) {
        _vm.deal.edit = 'no';
        _vm.deal.deal_value = _vm.content_cache;
        _vm.updateDeal(_vm.deal)
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content_cache = $event.target.value
      }
    }
  }), _vm._v(" \n        "), _c('p', {
    staticClass: "inline-block"
  }, [_c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.goContact(_vm.deal_contact.contact_token)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.deal_contact.name) + "  ")]), _vm._v(" "), _c('span', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        _vm.ShowOrganization(_vm.deal.deal_organization_token)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" " + _vm._s(_vm.deal.deal_organization_name) + "  ")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == 'no' || _vm.deal.edit != _vm.deal.deal_stage),
      expression: "deal.edit=='no' || deal.edit!=deal.deal_stage"
    }],
    staticClass: "pointer inline-block",
    on: {
      "click": function($event) {
        _vm.deal.edit = _vm.deal.deal_stage;
        _vm.stage_content_cache = _vm.deal.deal_stage
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(" " + _vm._s(_vm.StageName))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == _vm.deal.deal_stage),
      expression: "deal.edit==deal.deal_stage"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.stage_content_cache),
      expression: "stage_content_cache"
    }],
    staticClass: "inline-edit-input",
    on: {
      "blur": function($event) {
        _vm.deal.edit = 'no';
      },
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.stage_content_cache = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.deal.edit = 'no';
        _vm.deal.deal_stage = _vm.stage_content_cache;
        _vm.updateDeal(_vm.deal)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("階段")]), _vm._v(" "), _vm._l((_vm.stages), function(stage) {
    return _c('option', {
      domProps: {
        "value": stage.stage_no
      }
    }, [_vm._v("\n            " + _vm._s(stage.name) + "\n          ")])
  })], 2), _vm._v(" \n        "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == 'no' || _vm.deal.edit != _vm.deal.deal_owner),
      expression: "deal.edit=='no' || deal.edit!=deal.deal_owner"
    }],
    staticClass: "pointer inline-block",
    on: {
      "click": function($event) {
        _vm.deal.edit = _vm.deal.deal_owner;
        _vm.owner_content_cache = _vm.deal.deal_owner
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-link"
  }), _vm._v(" " + _vm._s(_vm.deal.deal_owner))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deal.edit == _vm.deal.deal_owner),
      expression: "deal.edit==deal.deal_owner"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.owner_content_cache),
      expression: "owner_content_cache"
    }],
    staticClass: "inline-edit-input",
    on: {
      "blur": function($event) {
        _vm.deal.edit = 'no';
      },
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.owner_content_cache = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.deal.edit = 'no';
        _vm.deal.deal_owner = _vm.owner_content_cache;
        _vm.updateDealOwner(_vm.deal)
      }]
    }
  }, _vm._l((_vm.company_users), function(user) {
    return _c('option', {
      domProps: {
        "value": user.name
      }
    }, [_vm._v("\n            " + _vm._s(user.name) + "\n          ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 deal_status_btns"
  }, [_c('div', [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      active: _vm.router == 'deal'
    },
    on: {
      "click": function($event) {
        _vm.goDeal(_vm.deal.deal_token)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-shopping-bag"
  }), _vm._v(" 銷售管理")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      active: _vm.router == 'deal_management'
    },
    on: {
      "click": function($event) {
        _vm.goDealManagement(_vm.deal.deal_token)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list-ol"
  }), _vm._v(" 專案管理")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      active: _vm.router == 'deal_finance'
    },
    on: {
      "click": function($event) {
        _vm.goDealFinance(_vm.deal.deal_token)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-dollar-sign"
  }), _vm._v(" 帳款管理")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c35818d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deals/DealHeader.vue
// module id = 692
// module chunks = 4